import React from "react";
import Typography from "./shared/Typography";
import AdSenseAd from "./AdSenseAd";
import { colors } from "../constants/colors";

function Terms() {
  const containerStyle = {
    minHeight: "100vh",
    backgroundColor: colors.extraLightGray,
    paddingTop: "2rem",
    paddingBottom: "4rem",
  };

  const contentStyle = {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const headerCardStyle = {
    backgroundColor: colors.white,
    borderRadius: "20px",
    padding: "3rem 2rem",
    marginBottom: "2rem",
    boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
    textAlign: "center",
    background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.lightBlue} 100%)`,
  };

  const sectionCardStyle = {
    backgroundColor: colors.white,
    borderRadius: "16px",
    padding: "2rem",
    marginBottom: "1.5rem",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    border: `1px solid ${colors.doubleExtraLightGray}`,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  };

  const sectionCardHoverStyle = {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
  };

  const listStyle = {
    margin: "1rem 0",
    paddingLeft: "0",
    listStyle: "none",
  };

  const listItemStyle = {
    backgroundColor: colors.lightBlue,
    margin: "0.5rem 0",
    padding: "0.75rem 1rem",
    borderRadius: "8px",
    borderLeft: `4px solid ${colors.darkGreen}`,
    transition: "all 0.2s ease",
  };

  const definitionListStyle = {
    margin: "1rem 0",
    paddingLeft: "0",
    listStyle: "none",
  };

  const definitionItemStyle = {
    backgroundColor: colors.lightGreen,
    margin: "0.75rem 0",
    padding: "1rem",
    borderRadius: "10px",
    borderLeft: `4px solid ${colors.darkGreen}`,
    transition: "all 0.2s ease",
  };

  const footerCardStyle = {
    backgroundColor: colors.darkBlue,
    color: colors.white,
    borderRadius: "16px",
    padding: "2rem",
    marginTop: "3rem",
    textAlign: "center",
    background: `linear-gradient(135deg, ${colors.darkBlue} 0%, ${colors.darkGreen} 100%)`,
  };

  const effectiveDateStyle = {
    backgroundColor: colors.lightGreen,
    padding: "1rem",
    borderRadius: "10px",
    border: `2px solid ${colors.darkGreen}`,
    marginBottom: "1rem",
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = sectionCardHoverStyle.transform;
    e.currentTarget.style.boxShadow = sectionCardHoverStyle.boxShadow;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = sectionCardStyle.boxShadow;
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        {/* Header Section */}
        <div style={headerCardStyle}>
          <Typography
            variant="h1"
            style={{
              marginBottom: "1rem",
              color: colors.darkBlue,
              fontSize: "clamp(2rem, 5vw, 3rem)",
            }}
          >
            Terms and Conditions for NutriPlate
          </Typography>
          <Typography
            variant="body"
            style={{
              color: colors.darkGray,
              fontWeight: "600",
              fontSize: "1.1rem",
            }}
          >
            Last updated: August 15, 2025
          </Typography>
          <Typography
            variant="body"
            style={{
              marginTop: "1rem",
              color: colors.darkGray,
              fontSize: "1rem",
              maxWidth: "600px",
              margin: "1rem auto 0",
            }}
          >
            Please read these terms and conditions carefully before using Our
            Service.
          </Typography>
        </div>

        {/* Interpretation and Definitions */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Interpretation and Definitions
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "1.5rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Interpretation
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1.5rem", lineHeight: "1.7" }}
          >
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "2rem",
              marginBottom: "1rem",
              color: colors.darkGreen,
            }}
          >
            Definitions
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            For the purposes of these Terms and Conditions:
          </Typography>
          <ul style={definitionListStyle}>
            <li style={definitionItemStyle}>
              <strong>Affiliate</strong> means an entity that controls, is
              controlled by or is under common control with a party, where
              "control" means ownership of 50% or more of the shares, equity
              interest or other securities entitled to vote for election of
              directors or other managing authority.
            </li>
            <li style={definitionItemStyle}>
              <strong>Company</strong> (referred to as either "the Company",
              "We", "Us" or "Our" in this Agreement) refers to the developer of
              NutriPlate.
            </li>
            <li style={definitionItemStyle}>
              <strong>Device</strong> means any device that can access the
              Service such as a computer, a cellphone or a digital tablet.
            </li>
            <li style={definitionItemStyle}>
              <strong>Health Data</strong> means any health, fitness, nutrition,
              or medical information that you provide to or that is collected by
              the Application, including but not limited to step counts, calorie
              intake, weight measurements, dietary preferences, and health
              conditions.
            </li>
            <li style={definitionItemStyle}>
              <strong>Premium Service</strong> refers to the paid subscription
              tier of the Application that provides enhanced features with
              higher limits than the free plan, including increased meal
              tracking capacity, more AI recipe generations, and advanced
              nutritional analysis.
            </li>
            <li style={definitionItemStyle}>
              <strong>RevenueCat</strong> refers to the third-party subscription
              management service used by the Company to manage subscription
              states, handle cross-platform subscription synchronization, and
              provide subscription analytics, while all actual payments are
              processed through the App Store.
            </li>
            <li style={definitionItemStyle}>
              <strong>Service</strong> refers to the NutriPlate mobile
              application.
            </li>
            <li style={definitionItemStyle}>
              <strong>Application</strong> refers to NutriPlate, the software
              program provided by the Company downloaded by You on any
              electronic device.
            </li>
            <li style={definitionItemStyle}>
              <strong>Third-party Health Services</strong> means health and
              fitness platforms such as Apple Health, Google Fit, and other
              integrated health data providers.
            </li>
            <li style={definitionItemStyle}>
              <strong>You</strong> means the individual accessing or using the
              Service, or the company, or other legal entity on behalf of which
              such individual is accessing or using the Service, as applicable.
            </li>
          </ul>
        </div>

        {/* Acknowledgment */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Acknowledgment
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            These are the Terms and Conditions governing the use of this Service
            and the agreement that operates between You and the Company. These
            Terms and Conditions set out the rights and obligations of all users
            regarding the use of the Service.
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            Your access to and use of the Service is conditioned on Your
            acceptance of and compliance with these Terms and Conditions. These
            Terms and Conditions apply to all visitors, users and others who
            access or use the Service.
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            By accessing or using the Service You agree to be bound by these
            Terms and Conditions. If You disagree with any part of these Terms
            and Conditions then You may not access the Service.
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            You represent that you are over the age of 13. If you are between 13
            and 18 years old, you may only use the Service with the involvement
            and consent of a parent or guardian.
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "0", lineHeight: "1.7" }}
          >
            Your access to and use of the Service is also conditioned on Your
            acceptance of and compliance with the Privacy Policy of the Company.
            Our Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your personal information when You
            use the Application and tells You about Your privacy rights and how
            the law protects You. Please read Our Privacy Policy carefully
            before using Our Service.
          </Typography>
        </div>

        {/* Description of Service */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Description of Service
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            NutriPlate is an AI-powered nutrition tracking and meal planning
            application that provides:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>
              <strong>Nutrition Tracking</strong>: Track your daily caloric
              intake and macronutrients (protein, carbohydrates, fat) as well as
              micronutrients (fiber, sugars, sodium, potassium, cholesterol)
            </li>
            <li style={listItemStyle}>
              <strong>AI Recipe Generation</strong>: Generate personalized
              recipes based on your dietary preferences, health conditions, and
              nutritional goals
            </li>
            <li style={listItemStyle}>
              <strong>Food Analysis</strong>: Analyze food through photos and
              barcode scanning to obtain nutritional information
            </li>
            <li style={listItemStyle}>
              <strong>Health Integration</strong>: Connect with Apple Health,
              Google Fit, and other health platforms to sync fitness and health
              data
            </li>
            <li style={listItemStyle}>
              <strong>Meal Planning</strong>: Create meal plans, save favorite
              meals, and track your meal history
            </li>
            <li style={listItemStyle}>
              <strong>Progress Analytics</strong>: View detailed analytics of
              your nutrition journey, weight tracking, and health milestones
            </li>
            <li style={listItemStyle}>
              <strong>Premium Features</strong>: Access enhanced daily meal
              tracking limits, increased AI recipe generations, and advanced
              nutritional analysis through our subscription service managed via
              RevenueCat
            </li>
          </ul>
        </div>

        {/* Advertisement */}
        <div
          style={{
            padding: "2rem 0",
            textAlign: "center",
          }}
        >
          <AdSenseAd
            adSlot="1234567895"
            style={{
              margin: "0 auto",
              maxWidth: "728px",
            }}
          />
        </div>

        {/* Health and Medical Disclaimers */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Health and Medical Disclaimers
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "1.5rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Not Medical Advice
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            The information provided by NutriPlate is for informational and
            educational purposes only and is not intended as medical advice. The
            nutritional information, AI-generated recipes, and health
            recommendations provided through the Service should not be used as a
            substitute for professional medical advice, diagnosis, or treatment.
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "1.5rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Consult Healthcare Professionals
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            Always seek the advice of your physician or other qualified health
            provider with any questions you may have regarding a medical
            condition, dietary changes, or fitness routine. Never disregard
            professional medical advice or delay in seeking it because of
            something you have read or learned through the Service.
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "1.5rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Accuracy of Nutritional Information
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            While we strive to provide accurate nutritional information, the
            data provided through food image analysis, barcode scanning, and AI
            recipe generation may contain inaccuracies. Nutritional values are
            estimates and may vary based on preparation methods, ingredient
            variations, and serving sizes.
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "1.5rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Individual Health Conditions
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "0", lineHeight: "1.7" }}
          >
            The Service may not be suitable for individuals with specific
            medical conditions, allergies, or dietary restrictions. It is your
            responsibility to verify that any recipes, meal plans, or
            nutritional recommendations are appropriate for your individual
            health needs and restrictions.
          </Typography>
        </div>

        {/* Two-Column Section for Subscriptions and User Data */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
            gap: "1.5rem",
            marginBottom: "1.5rem",
          }}
        >
          {/* Subscriptions and Premium Service */}
          <div
            style={sectionCardStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Typography
              variant="h2"
              style={{
                marginBottom: "1.5rem",
                color: colors.darkBlue,
                borderBottom: `2px solid ${colors.lightGreen}`,
                paddingBottom: "0.5rem",
                fontSize: "1.5rem",
              }}
            >
              Auto-Renewable Subscriptions
            </Typography>

            <Typography
              variant="h3"
              style={{
                marginTop: "1rem",
                marginBottom: "0.75rem",
                color: colors.darkGreen,
              }}
            >
              NutriPlate Premium Subscription
            </Typography>
            <Typography
              variant="body"
              style={{ marginBottom: "1rem", lineHeight: "1.7" }}
            >
              Our Premium subscription provides enhanced access to features with
              increased limits:
            </Typography>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                Significantly more daily meal tracking (higher limits than free
                plan)
              </li>
              <li style={listItemStyle}>
                More AI recipe generations per day (higher limits than free
                plan)
              </li>
              <li style={listItemStyle}>
                Enhanced nutritional analysis capabilities
              </li>
              <li style={listItemStyle}>Advanced analytics and insights</li>
              <li style={listItemStyle}>Priority customer support</li>
            </ul>

            <Typography
              variant="h3"
              style={{
                marginTop: "1.5rem",
                marginBottom: "0.75rem",
                color: colors.darkGreen,
              }}
            >
              Subscription Terms and Pricing
            </Typography>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <strong>Auto-Renewal:</strong> Subscriptions automatically renew
                unless cancelled at least 24 hours before the current period
                ends
              </li>
              <li style={listItemStyle}>
                <strong>Payment:</strong> Charged to your App Store account upon
                confirmation of purchase
              </li>
              <li style={listItemStyle}>
                <strong>Cancellation:</strong> You can cancel anytime through
                your App Store account settings
              </li>
            </ul>

            <Typography
              variant="body"
              style={{
                marginTop: "1rem",
                lineHeight: "1.7",
                fontSize: "0.9rem",
                backgroundColor: colors.lightBlue,
                padding: "1rem",
                borderRadius: "8px",
                borderLeft: `4px solid ${colors.darkGreen}`,
              }}
            >
              <strong>Important:</strong> Your subscription will be charged to
              your App Store account. Auto-renewal may be turned off by going to
              your Account Settings after purchase. No cancellation of the
              current subscription is allowed during active subscription period.
            </Typography>
          </div>

          {/* User Accounts and Data */}
          <div
            style={sectionCardStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Typography
              variant="h2"
              style={{
                marginBottom: "1.5rem",
                color: colors.darkBlue,
                borderBottom: `2px solid ${colors.lightGreen}`,
                paddingBottom: "0.5rem",
                fontSize: "1.5rem",
              }}
            >
              User Accounts & Data
            </Typography>

            <Typography
              variant="body"
              style={{ marginBottom: "1rem", lineHeight: "1.7" }}
            >
              By using the Service, you consent to our collection and processing
              of your Health Data including:
            </Typography>
            <ul style={listStyle}>
              <li style={listItemStyle}>Nutritional intake data</li>
              <li style={listItemStyle}>Health data from connected services</li>
              <li style={listItemStyle}>Weight and body measurements</li>
              <li style={listItemStyle}>Exercise and activity data</li>
            </ul>

            <Typography
              variant="body"
              style={{
                marginTop: "1rem",
                lineHeight: "1.7",
                fontSize: "0.9rem",
              }}
            >
              You are responsible for maintaining account security and data
              accuracy.
            </Typography>
          </div>

          {/* Advertisement */}
          <div
            style={{
              padding: "2rem 0",
              textAlign: "center",
            }}
          >
            <AdSenseAd
              adSlot="1234567896"
              style={{
                margin: "0 auto",
                maxWidth: "728px",
              }}
            />
          </div>
        </div>

        {/* Payment Methods and App Store Compliance */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Payment Methods and App Store Compliance
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "1rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Supported Payment Methods
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            NutriPlate uses RevenueCat to manage subscriptions and processes all
            payments through the official App Store payment system:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>
              <strong>iOS App Store:</strong> All payments processed through
              Apple's secure payment system
            </li>
            <li style={listItemStyle}>
              <strong>RevenueCat Integration:</strong> We use RevenueCat to
              manage subscription states and provide cross-platform subscription
              management
            </li>
            <li style={listItemStyle}>
              <strong>No Direct Payment Processing:</strong> We do not integrate
              Apple Pay or direct payment processing within the app
            </li>
            <li style={listItemStyle}>
              <strong>Subscription Management:</strong> All subscription changes
              must be made through your App Store account
            </li>
            <li style={listItemStyle}>
              <strong>Refunds:</strong> All refund requests must be processed
              through the App Store according to Apple's refund policy
            </li>
          </ul>

          <Typography
            variant="body"
            style={{
              marginTop: "1rem",
              lineHeight: "1.7",
              fontSize: "0.9rem",
              backgroundColor: colors.lightBlue,
              padding: "1rem",
              borderRadius: "8px",
              borderLeft: `4px solid ${colors.darkGreen}`,
            }}
          >
            <strong>Note:</strong> NutriPlate uses RevenueCat for subscription
            management but does not implement Apple Pay, in-app direct payments,
            or any payment processing frameworks within the application itself.
            All transactions are handled exclusively through the App Store's
            subscription system, with RevenueCat providing subscription state
            management and analytics.
          </Typography>
        </div>

        {/* Limitation of Liability - Full Width */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Limitation of Liability & Important Legal Information
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            <strong>Important:</strong> To the maximum extent permitted by law,
            the Company shall not be liable for any special, incidental,
            indirect, or consequential damages arising from your use of the
            Service, including but not limited to health complications, data
            loss, or business interruption.
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            The Service is provided "AS IS" and "AS AVAILABLE" without warranty.
            We disclaim all warranties regarding the accuracy of nutritional
            information, suitability of AI-generated recipes for your health
            conditions, or uninterrupted integration with third-party health
            services.
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "0", lineHeight: "1.7" }}
          >
            User conduct restrictions include: no unlawful use, no sharing false
            health information, no unauthorized access attempts, and no
            commercial exploitation without permission.
          </Typography>
        </div>

        {/* Footer with Effective Date and Legal Links */}
        <div style={footerCardStyle}>
          <div style={effectiveDateStyle}>
            <Typography
              variant="body"
              style={{
                fontWeight: "bold",
                color: colors.darkGreen,
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              Effective Date: These Terms and Conditions are effective as of
              August 15, 2025.
            </Typography>

            <Typography
              variant="h3"
              style={{
                color: colors.darkGreen,
                textAlign: "center",
                marginBottom: "0.75rem",
                fontSize: "1.2rem",
              }}
            >
              Required Legal Links
            </Typography>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <Typography
                variant="body"
                style={{
                  color: colors.darkGreen,
                  fontWeight: "600",
                }}
              >
                📄 Terms of Use (EULA): This document serves as our Terms of Use
              </Typography>
              <Typography
                variant="body"
                style={{
                  color: colors.darkGreen,
                  fontWeight: "600",
                }}
              >
                🔒 Privacy Policy: Available at /privacy in this application
              </Typography>
              <Typography
                variant="body"
                style={{
                  color: colors.darkGreen,
                  fontWeight: "600",
                  fontSize: "0.9rem",
                }}
              >
                💳 For subscription management, use your App Store account
                settings
              </Typography>
            </div>
          </div>

          <Typography
            variant="body"
            style={{
              color: colors.white,
              textAlign: "center",
              lineHeight: "1.6",
            }}
          >
            By using NutriPlate, you acknowledge that you have read, understood,
            and agree to be bound by these Terms and Conditions and our Privacy
            Policy.
          </Typography>

          {/* Company Information */}
          <div
            style={{
              backgroundColor: colors.white,
              padding: "1.5rem",
              borderRadius: "12px",
              border: `2px solid ${colors.lightGreen}`,
              marginTop: "2rem",
              marginBottom: "2rem",
            }}
          >
            <Typography
              variant="body"
              style={{
                color: colors.darkBlue,
                fontWeight: "600",
                marginBottom: "0.5rem",
                fontSize: "1rem",
                textAlign: "center",
              }}
            >
              Service Provider
            </Typography>
            <Typography
              variant="body"
              style={{
                color: colors.darkGreen,
                fontWeight: "bold",
                fontSize: "1.1rem",
                marginBottom: "0.5rem",
                textAlign: "center",
              }}
            >
              RayaTech AB
            </Typography>
            <Typography
              variant="body"
              style={{
                color: colors.darkGray,
                fontSize: "0.9rem",
                marginBottom: "0.3rem",
                textAlign: "center",
              }}
            >
              Organization Number: 559546-6904
            </Typography>
            <Typography
              variant="body"
              style={{
                color: colors.darkGray,
                fontSize: "0.9rem",
                textAlign: "center",
              }}
            >
              Stockholm, Sweden
            </Typography>
          </div>

          <Typography
            variant="body"
            style={{
              color: colors.white,
              textAlign: "center",
              marginTop: "1rem",
              opacity: "0.9",
            }}
          >
            Questions? Contact us at support@nutriplate.com or through the
            support options in the NutriPlate application.
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default Terms;
